import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Button } from "@circle-react-uikit/Button";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";
import { useCommunityMemberPickerContext } from "../CommunityMemberPickerContext";

export interface SummaryProps extends React.HTMLAttributes<HTMLDivElement> {
  buttonLabel?: string;
  countLabel?: string;
  onClick: () => void;
  tooltipText?: string;
}

export const Summary = ({
  buttonLabel,
  countLabel,
  tooltipText,
  onClick,
  ...passThroughProps
}: SummaryProps) => {
  const { selectionState } = useCommunityMemberPickerContext();
  const { memberCount: count = 0, isLoading } = selectionState;
  const label = `${count} ${
    countLabel || t("community_member_select.count_label")
  }`;
  const defaultButtonLabel = count > 0 ? t("manage") : t("add");

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div
      className="flex w-full items-center justify-between"
      {...passThroughProps}
    >
      <div>
        <Typography.LabelSm>{label}</Typography.LabelSm>
        {tooltipText && (
          <TippyV2 content={tooltipText}>
            <Icon type="question-mark" className="icon icon--xs ml-2" />
          </TippyV2>
        )}
      </div>
      <Button
        type="button"
        variant="secondary"
        onClick={onClick}
        className="w-24"
      >
        {buttonLabel || defaultButtonLabel}
      </Button>
    </div>
  );
};
